import { useQuery } from "@tanstack/react-query";
import { getInboxData } from "../../Requests";
import { useAppSelector } from "..";

function useInboxQuery(municipalKey: string) {
  const access_token = useAppSelector(state => state.auth.user?.access_token) ?? '';

  return useQuery({
    queryKey: ["inbox", municipalKey],
    queryFn: () => getInboxData(municipalKey, access_token),
    enabled: !!access_token,
  });
}

export { useInboxQuery };
